import { BASE_URL } from "../config";

class Model {
  constructor() {
    this.bgvideo = {
      landing: `${BASE_URL}video/Holding_Screen_and_Content_Screen_Upscaled.mp4`,
    };

    this.landingvideo = [
      {
        id: "lv1",
        video: `${BASE_URL}video/Learn_more_about_Infosys.mp4`,
      },
      {
        id: "lv2",
        video: `${BASE_URL}video/See_AI_across_the_Energy_Value_chain.mp4`,
      },
      {
        id: "lv3",
        video: `${BASE_URL}video/Discover_AI_for_Energy_Evolution.mp4`,
      },
    ];

    this.sections = [
      {
        id: "upstream",
        bgvideo: `${BASE_URL}video/Upstream_Upscaled.mp4`,
        title: "UPSTREAM",
        desc: "Optimizing safety, efficiency, and decision-making across exploration, drilling, and production operations.",
        cards: [
          {
            id: "u1",
            flipid: "u3",
            title: "OIL & GAS ASSISTANT",
            type: "",
            tag: {
              title: "Case Study",
              images: [`${BASE_URL}images/Oil_and_Gas_Assistant.jpg`],
            },
            image: {
              thumbnail: `${BASE_URL}images/thumb_Oil_&_Gas_ Assistant.jpg`,
            },
            vidthumbnail: "no",
            specialtag: "no",
          },

          {
            id: "u2",
            flipid: "u4",
            title: "SHALLOW HAZARD RISK ANALYSIS",
            type: "",
            tag: {
              title: "Case Study",
              images: [`${BASE_URL}images/Shallow_Hazard_Risk_Analysis.jpg`],
            },
            image: {
              thumbnail: `${BASE_URL}images/thumb_Shallow_Hazard_Risk_Analysis.jpg`,
            },
            vidthumbnail: "no",
            specialtag: "no",
          },
          {
            id: "u3",
            flipid: "u5",
            title: "AVEVA PI AGENT",
            type: "singlevideo",
            tag: {
              title: "Case Study",
              images: [`${BASE_URL}images/pi_agent.png`],
            },
            image: {
              thumbnail: `${BASE_URL}images/thumb_pi_agent.jpg`,
              video: `${BASE_URL}video/AI_Subsurface_Data_Curator.mp4`,
            },
            vidthumbnail: "yes",
            specialtag: "no",
          },
          {
            id: "u4",
            flipid: "u6",
            title: "AI-POWERED HSE DATA EXTRACTION",
            type: "",
            tag: {
              title: "Case Study",
              images: [`${BASE_URL}images/AI-powered_HSE_Data_Extraction.jpg`],
            },
            image: {
              thumbnail: `${BASE_URL}images/thumb_AI-powered_HSE_Data_Extraction.jpg`,
              // video: `${BASE_URL}video/AI_powered_HSE_Data_Extraction.mp4`,
            },
            vidthumbnail: "no",
            specialtag: "no",
          },
          {
            id: "u5",
            flipid: "u8",
            title: "DRILLING AI AGENT",
            type: "singlevideo",
            tag: {
              title: "Case Study",
              images: [`${BASE_URL}images/Drilling_AI_Agent.jpg`],
            },
            image: {
              thumbnail: `${BASE_URL}images/thumb_Drilling_AI _Agent.jpg`,
              video: `${BASE_URL}video/Drilling_AI_Agent.mp4`,
            },
            vidthumbnail: "yes",
            specialtag: "no",
          },

          {
            id: "u6",
            flipid: "u7",
            title: "WELL BORE SCHEMATIC INTELLIGENT AUTOMATION",
            type: "singlevideo",
            tag: {
              title: "Case Study",
              images: [
                `${BASE_URL}images/Well_Bore_Schematic_Intelligent_Automation.jpg`,
              ],
            },
            image: {
              thumbnail: `${BASE_URL}images/thumb_Site_Reliability_Engineering.jpg`,
              video: `${BASE_URL}video/Site_Reliability_Engineering.mp4`,
            },
            vidthumbnail: "yes",
            specialtag: "no",
          },
          {
            id: "u7",
            flipid: "u2",
            title: "DECOM (INFOSYS WITH PLANSEA)",
            type: "singlevideo",
            tag: {
              title: "Explainer Video",
            },
            image: {
              thumbnail: `${BASE_URL}images/thumb_DECOM.jpeg`,
              video: `${BASE_URL}video/Transcoded_ONS_DECOM_EXPLAINER.mp4`,
            },
            vidthumbnail: "yes",
            specialtag: "yes",
          },
        ],
      },
      {
        id: "refining",
        bgvideo: `${BASE_URL}video/Refining_Upscaled.mp4`,
        title: "REFINING",
        desc: "Empowering refinery teams with enhanced processing, improved reliability, and increased profitability.",
        cards: [
          {
            id: "r1",
            flipid: "u3",
            title: "Refinery Operation Excellence",
            desc: "Enables better feedstock decisions and capitalizes on trading opportunities for a competitive edge, contributing to a 2% increase in plant availability.",
            image: `${BASE_URL}images/thumb_refinery.jpg`,
            type: "",
            vidthumbnail: "no",
          },
          {
            id: "r2",
            flipid: "u7",
            title: "Turnaround Performance",
            desc: "Improves turnaround readiness and optimizes resource planning to reduce third-party expenses by 12% annually.",
            image: `${BASE_URL}images/thumb_turnaround.jpg`,
            type: "",
            vidthumbnail: "no",
          },
          // {
          //   id: "r3",
          //   flipid: "u5",
          //   title: "Coke Quality <br> Analytics",
          //   desc: "Reduces safety incidents by mitigating shot coke events and delivers approximately 15% in annual savings for the refinery coke business.",
          //   image: `${BASE_URL}images/thumb_coke.jpg`,
          //   type: "",
          //   vidthumbnail: "no",

          // },
          {
            id: "r3",
            flipid: "u5",
            title: "Coke Quality <br> Analytics",
            desc: "Reduces safety incidents by mitigating shot coke events and delivers approximately 15% in annual savings for the refinery coke business.",
            image: {
              thumbnail: `${BASE_URL}images/thumb_coke.jpg`,
              video: `${BASE_URL}video/Coke_Quality_Analytics.mp4`,
            },
            type: "singlevideo",
            vidthumbnail: "yes",
          },
          {
            id: "r4",
            flipid: "",
            title: "CONTRACT VALUE LEAKAGE ANALYSIS",
            type: "",
            desc: "An AI-driven framework for detecting and preventing financial leakages and revenue loss within contracts.",
            tag: {
              title: "Case Study",
              images: [`${BASE_URL}images/Contract_Value_Leakage_Analysis.jpg`],
            },
            image: {
              thumbnail: `${BASE_URL}images/thumb_Contract_Value _Leakage_Analysis.jpg`,
            },
            vidthumbnail: "no",
            specialtag: "no",
          },
          {
            id: "r5",
            flipid: "",
            title: "AI-POWERED FLARE PREDICTION",
            type: "",
            desc: "A predictive analytics solution to forecast flaring events and identify optimization opportunities.",
            tag: {
              title: "Case Study",
              images: [`${BASE_URL}images/AI-powered_Flare_Prediction.jpg`],
            },
            image: {
              thumbnail: `${BASE_URL}images/thumb_AI-powered_Flare_Prediction.jpg`,
            },
            vidthumbnail: "no",
            specialtag: "no",
          },
          // {
          //   id: "r6",
          //   flipid: "",
          //   title: "LiDAR OBJECT DETECTION FOR DIGITAL TWIN",
          //   type: "",
          //   desc: "Applies AI-powered object detection to LIDAR data, ensuring digital twin accuracy and enhancing engineering productivity.",
          //   tag: {
          //     title: "Case Study",
          //     images: [
          //       `${BASE_URL}images/LiDAR_Object_Detection_for_Digital_Twin.jpg`,
          //     ],
          //   },
          //   image: {
          //     thumbnail: `${BASE_URL}images/thumb_LiDAR_Object_Detection_for_Digital.jpg`,
          //   },
          //   vidthumbnail: "no",
          //   specialtag: "no",
          // },
          {
            id: "r6",
            flipid: "",
            title: "ID CONTENT <br> EXTRACTION",
            type: "",
            desc: "Employs computer vision to identify symbols and extract data from engineering diagrams, ensuring synchronization with digital twin applications.",
            tag: {
              title: "Case Study",
              images: [`${BASE_URL}images/ID_Content_Extraction.jpg`],
            },
            image: {
              thumbnail: `${BASE_URL}images/thumb_freepik__futuristic-flatstyle.jpg`,
            },
            vidthumbnail: "no",
            specialtag: "no",
          },
        ],
      },
      {
        id: "trading",
        bgvideo: `${BASE_URL}video/Trading_and_Supply_Chain_Upscaled.mp4`,
        title: "TRADING AND SUPPLY CHAIN",
        desc: "Delivering front-to-back commodity lifecycle solutions that power smarter trading, streamlined operations, and proactive risk management.",
        cards: [
          {
            id: "t1",
            flipid: "u5",
            title: "MRE Consulting",
            desc: "A strategic consulting partner that delivers deep Energy & Commodity Trading and Risk Management (E/CTRM) expertise to accelerate digital transformation and drive client value.",
            image: {
              thumbnail: `${BASE_URL}images/thumb_mre.jpg`,
              video: `${BASE_URL}video/MRE_Consulting.mp4`,
            },
            type: "singlevideo",
            vidthumbnail: "yes",
          },
          {
            id: "t2",
            flipid: "u4",
            title: "Maritime Operations",
            desc: "A GenAI-driven virtual vessel assistant that proactively analyzes sensor data and manuals to enable smarter maintenance decisions and unlock significant fleet savings.",
            image: {
              thumbnail: `${BASE_URL}images/thumb_Maritime_Operations.jpg`,
              video: `${BASE_URL}video/Maritime_Ops.mp4`,
            },
            type: "singlevideo",
            vidthumbnail: "yes",
          },
          {
            id: "t3",
            flipid: "u1",
            title: "Trading AI Agent",
            desc: "An AI-powered collaborator that automatically processes trading documents in real-time to generate and identify trade optimization opportunities.",
            image: {
              thumbnail: `${BASE_URL}images/thumb_tradingagent.jpg`,
              video: `${BASE_URL}video/Trading_AI_Agent.mp4`,
            },
            type: "singlevideo",
            vidthumbnail: "yes",
          },
          {
            id: "t4",
            smallfont: "yes",
            flipid: "u2",
            title: "AI-powered Contract Validation",
            desc: "An AI-driven document extraction solution that automates commercial term validation and compliance checks, cutting contract processing time in half while strengthening risk management.",
            tag: {
              title: "Case Study",
              images: [
                `${BASE_URL}images/Pop_up_AI_Powered_contract_validation.jpg`,
              ],
            },
            image: {
              thumbnail: `${BASE_URL}images/thumb_AI_Powered_contract_validation.jpg`,
            },
            vidthumbnail: "no",
            specialtag: "no",
          },
        ],
      },
      {
        id: "responsibleai",
        bgvideo: `${BASE_URL}video/Responsible_AI_Upscaled.mp4`,
        title: "RESPONSIBLE AI",
        desc: "Building trust and ensuring ethical integrity in every AI system.",
        cards: [
          {
            id: "a1",
            flipid: "u2",
            title: "UNESCO Ethical AI Partnership",
            desc: "A strategic collaboration to adopt and implement UNESCO's global ethical AI framework, ensuring fairness, transparency, and accountability in AI systems.",
            image: {
              thumbnail: `${BASE_URL}images/thunmb_unesco.jpg`,
              video: `${BASE_URL}video/UNESCO_Ethical_AI_Partnership.mp4`,
            },
            type: "singlevideo",
            vidthumbnail: "yes",
          },
          {
            id: "a2",
            flipid: "u6",
            title: "AI Security",
            desc: "A comprehensive suite of solutions to protect AI models from adversarial attacks, detect vulnerabilities, and ensure secure, responsible AI deployment across the enterprise.",
            image: {
              thumbnail: `${BASE_URL}images/thumb_ai_security.jpg`,
              video: `${BASE_URL}video/AI_Security.mp4`,
            },
            type: "singlevideo",
            vidthumbnail: "yes",
          },
          {
            id: "a3",
            flipid: "u4",
            title: "Responsible AI Toolkit",
            desc: "An open-source solution that provides tools and frameworks to enhance trust, transparency, and ethical compliance in AI systems across the development lifecycle.",
            image: {
              thumbnail: `${BASE_URL}images/thumb_responsibleai.jpg`,
              video: `${BASE_URL}video/Responsible_AI_Toolkit.mp4`,
            },
            type: "singlevideo",
            vidthumbnail: "yes",
          },
        ],
      },
      {
        id: "retail",
        bgvideo: `${BASE_URL}video/Retail_and_Mobility_Upscaled.mp4`,
        title: "RETAIL AND MOBILITY",
        desc: "Transforming customer experiences through modern retail solutions and intelligent mobility services.",
        cards: [
          {
            id: "m1",
            flipid: "u4",
            title: "Retail",
            desc: "Modernizes store operations, enhances loyalty programs, and optimizes retail management to deliver seamless customer experiences.",
            image: `${BASE_URL}images/thumb_retail.jpg`,
            tag: [
              {
                title: "AI-enabled Pricing",
                videos: [
                  {
                    id: "m1v1",
                    src: `${BASE_URL}video/Infosys_Equinox_Strategic_Offering.mp4`,
                    thumbnail: "images/refining/thumb-coke1.jpg",
                  },
                ],
              },
              {
                title: "Autonomous Supply Chain Solution",
                videos: [
                  {
                    id: "m1v2",
                    src: `${BASE_URL}video/Infosys_Autonomous_Supply_Chain_Solution.mp4`,
                    thumbnail: "images/refining/thumb-coke3.jpg",
                  },
                ],
              },
              {
                title: "Accelerating AI",
                videos: [
                  {
                    id: "m1v3",
                    src: `${BASE_URL}video/Loyalty_Program.mp4`,
                    thumbnail: "images/refining/thumb-coke3.jpg",
                  },
                ],
              },
            ],
            type: "singlevideo",
            vidthumbnail: "no",
          },
          {
            id: "m2",
            flipid: "u1",
            title: "MOBILITY",
            desc: "Revolutionizes retail with <br>AI-driven strategies, enhances customer experience through intelligent insights, and elevates operations using Agentic AI.",
            image: {
              thumbnail: `${BASE_URL}images/thumb_mobility.jpg`,
              video: `${BASE_URL}video/Mobility.mp4`,
            },
            type: "singlevideo",
            vidthumbnail: "yes",
          },
        ],
      },
      {
        id: "enterprise",
        bgvideo: `${BASE_URL}video/Enterprise_Upscaled.mp4`,
        title: "ENTERPRISE",
        desc: "Integrating cross-functional intelligence to streamline operations and enhance business performance.",
        cards: [
          {
            id: "e1",
            flipid: "u1",
            title: "Shared Services Transformation",
            desc: "AI-powered solutions that automate and optimize back-office operations, driving efficiency, accuracy, and agility across finance and enterprise functions.",
            image: {
              thumbnail: `${BASE_URL}images/thumb_SharedServicesTransformation.jpg`,
              video: `${BASE_URL}video/Shared_Services_Transformation.mp4`,
            },
            type: "singlevideo",
            vidthumbnail: "yes",
          },
          {
            id: "e2",
            flipid: "u2",
            title: "AI-employee Experience",
            desc: "AI-driven tools that personalize onboarding, learning, and career development for employees.",
            image: `${BASE_URL}images/thumb_AI-employee-Experience.jpg`,
            tag: {
              title: "View Gallery",
              images: [
                `${BASE_URL}images/1.jpg`,
                `${BASE_URL}images/2.jpg`,
                `${BASE_URL}images/3.jpg`,
                `${BASE_URL}images/4.jpg`,
                `${BASE_URL}images/5.jpg`,
              ],
            },
            type: "",
            vidthumbnail: "no",
          },
          {
            id: "e3",
            flipid: "u3",
            title: "ERP",
            desc: "AI-driven solutions that optimize business processes and accelerate enterprise-wide digital transformation.",
            image: `${BASE_URL}images/thumb_ERP.jpg`,
            tag: [
              {
                title: "Oracle",
                videos: [
                  {
                    id: "e3v1",
                    title: "AI Workbench for Oracle",
                    src: `${BASE_URL}video/oracle1.mp4`,
                    thumbnail: "images/refining/thumb-coke1.jpg",
                  },
                  {
                    id: "e3v2",
                    title: "Infosys Enterprise Suite for Oracle",
                    src: `${BASE_URL}video/oracle2.mp4`,
                    thumbnail: "images/refining/thumb-coke1.jpg",
                  },
                ],
              },
              {
                title: "SAP",
                videos: [
                  {
                    id: "e3v3",
                    title: "Infosys Gen AI SDLC Framework",
                    src: `${BASE_URL}video/sap2.mp4`,
                    thumbnail: "images/refining/thumb-coke1.jpg",
                  },
                  {
                    id: "e3v4",
                    title: "Infosys Rise with SAP",
                    src: `${BASE_URL}video/sap3.mp4`,
                    thumbnail: "images/refining/thumb-coke1.jpg",
                  },
                ],
              },
              {
                title: "Microsoft",
                videos: [
                  {
                    id: "e3v5",
                    title: "Infosys Microsoft Practice",
                    src: `${BASE_URL}video/Microsoft.mp4`,
                    thumbnail: "images/refining/thumb-coke3.jpg",
                  },
                ],
              },
            ],
            type: "multivideo",
            vidthumbnail: "no",
          },
        ],
      },
      {
        id: "technology",
        bgvideo: `${BASE_URL}video/Technology_Upscaled.mp4`,
        title: "TECHNOLOGY",
        desc: "Providing core platforms and digital capabilities that power intelligent energy operations.",
        cards: [
          {
            id: "b1",
            flipid: "u7",
            title: "Legacy Modernization",
            desc: "Transforms outdated systems into agile, cloud-native platforms to enable connected mobility and data-driven operations.",
            image: {
              thumbnail: `${BASE_URL}images/thumb_legasy.jpg`,
              video: `${BASE_URL}video/Legacy_Modernization.mp4`,
            },
            tag: "",
            type: "singlevideo",
            vidthumbnail: "yes",
          },
          {
            id: "b2",
            flipid: "u8",
            title: "AI in Software Development",
            desc: "Automates and accelerates software development life cycle phases to enable faster, higher-quality application delivery.",
            image: {
              thumbnail: `${BASE_URL}images/thumb_sldc.jpg`,
              video: `${BASE_URL}video/AI_in_SLDC.mp4`,
            },
            tag: "",
            type: "singlevideo",
            vidthumbnail: "yes",
          },
          {
            id: "b3",
            flipid: "u1",
            title: "Cloud Transformation",
            desc: "Enables enterprise digital acceleration through cloud ecosystems that drive innovation and sustainable growth.",
            image: {
              thumbnail: `${BASE_URL}images/thumb_cloud.png`,
              video: `${BASE_URL}video/Cloud_Transformation.mp4`,
            },
            tag: "",
            type: "singlevideo",
            vidthumbnail: "yes",
          },
        ],
      },
      {
        id: "energytransition",
        bgvideo: `${BASE_URL}video/Energy_Transition_Upscaled.mp4`,
        title: "ENERGY TRANSITION",
        desc: "Accelerating the shift to sustainable operations and a lower-carbon future.",
        cards: [
          {
            id: "s1",
            flipid: "u6",
            title: "Energy-as-a-Service",
            desc: "<br><br>An AI-powered platform that enables enterprises to optimize energy consumption, integrate renewables, and reduce costs across their operations.",
            image: {
              thumbnail: `${BASE_URL}images/thumb_energyasaservice.jpg`,
              video: `${BASE_URL}video/Energy_as_a_Service.mp4`,
            },
            tag: "",
            type: "singlevideo",
            vidthumbnail: "yes",
          },
          {
            id: "s2",
            flipid: "u8",
            title: "Cloud Energy Management Platform",
            desc: "A cloud-based solution helping grid operators balance supply and demand by intelligently drawing on solar, wind, and stored power.",
            image: {
              thumbnail: `${BASE_URL}images/thumb_cemp.jpg`,
              video: `${BASE_URL}video/CEMP.mp4`,
            },
            tag: "",
            type: "singlevideo",
            vidthumbnail: "yes",
          },
          {
            id: "s3",
            flipid: "u7",
            title: "GHG Emissions <br> Platform",
            desc: "An AI-driven solution that automates emissions tracking and reporting, enabling real-time data streaming and audit-ready compliance for sustainable operations.",
            image: {
              thumbnail: `${BASE_URL}images/thumb_ghg.jpg`,
              video: `${BASE_URL}video/On_Track_for_Transparency.mp4`,
            },
            tag: "",
            type: "singlevideo",
            vidthumbnail: "yes",
          },
        ],
      },
    ];

    this.videoToLoad = [];
    this.imageToLoad = [];
    this.sections.forEach((section) => {
      // 1️⃣ Background video
      if (section.bgvideo) {
        const key = section.bgvideo.split("/").pop();
        this.videoToLoad.push({
          key,
          url: section.bgvideo,
          status: "not_loaded",
        });
      }

      // 2️⃣ Card-level videos
      section.cards?.forEach((card) => {
        // Single video card (e.g., Upstream)
        if (card.image?.video) {
          const key = card.image.video.split("/").pop();
          this.videoToLoad.push({
            key,
            url: card.image.video,
            status: "not_loaded",
          });
        }

        // Multi-video card (e.g., ERP)
        if (Array.isArray(card.tag)) {
          card.tag.forEach((tag) => {
            tag.videos?.forEach((videoObj) => {
              if (videoObj.src) {
                const key = videoObj.src.split("/").pop();
                this.videoToLoad.push({
                  key,
                  url: videoObj.src,
                  status: "not_loaded",
                });
              }
            });
          });
        }
      });
    });
    this.landingvideo.forEach((v) => {
      const key = v.video.split("/").pop();
      this.videoToLoad.push({
        key,
        url: v.video,
        status: "not_loaded",
      });
    });
    this.videoArr = [];
    this.videoToLoad.push({
      key: "Holding_Screen_and_Content_Screen_Upscaled.mp4",
      url: this.bgvideo.landing,
      status: "not_loaded",
    });
    this.imageArr = [];
    this.collectImages();
    this.videoLoadIndex = -1;
    this.imageLoadIndex = -1;
    // this.loadAssets();

    const criticalKeys = new Set([
      "Holding_Screen_and_Content_Screen_Upscaled.mp4",
      "Learn_more_about_Infosys.mp4",
      "See_AI_across_the_Energy_Value_chain.mp4",
      "Discover_AI_for_Energy_Evolution.mp4",
      // Add all section bgvideo keys
      // ...this.sections
      //   .filter((s) => s.bgvideo)
      //   .map((s) => s.bgvideo.split("/").pop()),
    ]);

    this.videoToLoad.forEach((v) => {
      v.priority = criticalKeys.has(v.key) ? "critical" : "background";
    });

    // console.log(this.videoToLoad);
  }

  // loadAssets(handler) {
  //   this.videoLoadIndex++;
  //   const loaderBar = document.querySelector(".loader-bar");
  //   const loaderText = document.getElementById("loader-text");
  //   if (this.videoLoadIndex <= this.videoToLoad.length - 1) {
  //     const progress = Math.floor(
  //       (this.videoLoadIndex / this.videoToLoad.length) * 50,
  //     );
  //     if (loaderBar) loaderBar.style.width = `${progress}%`;
  //     if (loaderText) loaderText.textContent = `Loading Videos ${progress}%`;
  //     this.preloadVideo(
  //       `${this.videoToLoad[this.videoLoadIndex]["url"]}?raw=true`,
  //       this.videoToLoad[this.videoLoadIndex]["key"],
  //       1,
  //     ).then(
  //       function (loadIndex) {
  //         // this.videoToLoad["status"] = "loaded";

  //         this.loadAssets(handler);
  //       }.bind(this),
  //     );
  //   } else {
  //     this.loadAssetsImage(handler);
  //   }
  // }

  loadAssets(handler) {
    const critical = this.videoToLoad.filter((v) => v.priority === "critical");
    const background = this.videoToLoad.filter(
      (v) => v.priority === "background",
    );

    const loaderBar = document.querySelector(".loader-bar");
    const loaderText = document.getElementById("loader-text");

    let loaded = 0;
    const total = critical.length;

    // Phase 1: load critical videos sequentially (blocks reveal)
    const loadNext = (index) => {
      if (index >= critical.length) {
        // Critical done — now load images, then reveal
        this.loadAssetsImage(() => {
          handler(); // reveal the page

          // Phase 2: load background videos silently after reveal
          background.forEach((v) => {
            this.preloadVideo(`${v.url}`, v.key, 1).then(() => {
              this.updateSections();
              this.updateLandingVideos();
            });
          });
        });
        return;
      }

      const v = critical[index];
      const progress = Math.floor((index / total) * 50);
      if (loaderBar) loaderBar.style.width = `${progress}%`;
      if (loaderText) loaderText.textContent = `Loading Videos ${progress}%`;

      this.preloadVideo(`${v.url}`, v.key, 1).then(() => {
        loadNext(index + 1);
      });
    };

    loadNext(0);
  }
  loadAssetsImage(handler) {
    this.imageLoadIndex++;
    const loaderBar = document.querySelector(".loader-bar");
    const loaderText = document.getElementById("loader-text");
    if (this.imageLoadIndex <= this.imageToLoad.length - 1) {
      const progress =
        50 + Math.floor((this.imageLoadIndex / this.imageToLoad.length) * 50); // 50–100% for images
      if (loaderBar) loaderBar.style.width = `${progress}%`;
      if (loaderText) loaderText.textContent = `Loading Images ${progress}%`;
      this.preloadImage(
        `${this.imageToLoad[this.imageLoadIndex]["url"]}`,
        this.imageToLoad[this.imageLoadIndex]["key"],
        1,
      ).then(
        function (loadIndex) {
          // this.videoToLoad["status"] = "loaded";

          this.loadAssetsImage(handler);
        }.bind(this),
      );
    } else {
      if (loaderBar) loaderBar.style.width = `100%`;
      if (loaderText) loaderText.textContent = `Done!`;
      this.updateSections();
      this.updateLandingVideos();
      const key = this.getVideoKeyFromUrl(this.bgvideo.landing);
      const blobUrl = this.getBlobUrl(key);
      if (blobUrl) this.bgvideo.landing = blobUrl;
      this.updateSectionImages();

      const loader = document.getElementById("loading-screen");
      handler();
      if (loader) {
        loader.style.opacity = 0;
        setTimeout(() => (loader.style.display = "none"), 600);
      }
    }
  }
  getVideoKeyFromUrl(url) {
    return url?.split("/").pop(); // e.g. "Energy_as_a_Service"
  }
  getBlobUrl(key) {
    const found = this.videoArr.find((v) => v.key === key);
    if (found) {
      return found.data;
    }
  }

  getSectionById(id) {
    return this.sections.find((s) => s.id === id);
  }
  preloadVideo(video_url, video_key, video_index, loaderContext) {
    return new Promise(
      function (
        video_url,
        video_key,
        video_index,
        loaderContext,
        resolve,
        reject,
      ) {
        var video_history = this.videoArr.filter(function (obj) {
          return obj.key === video_key;
        });
        if (video_history.length > 0) {
          console.log("Video already exist in array ", video_history);
          resolve(video_key);
          return;
        } else {
          this.videoArr.push({
            key: video_key,
            data: null,
            loaded: 0,
          });
          var r = new XMLHttpRequest();

          r.onload = function (
            video_url,
            video_key,
            video_index,
            loaderContext,
          ) {
            var video_obj = this.videoArr.filter(function (obj) {
              return obj.key === video_key;
            });
            video_obj[0].data = URL.createObjectURL(r.response);
            video_obj[0].loaded = 100;
            resolve(video_key);
          }.bind(this, video_url, video_key, video_index, loaderContext);
          r.open("GET", video_url);
          r.responseType = "blob";
          r.send();
        }
      }.bind(this, video_url, video_key, video_index, loaderContext),
    );
  }
  preloadImage(video_url, video_key, video_index, loaderContext) {
    return new Promise(
      function (
        video_url,
        video_key,
        video_index,
        loaderContext,
        resolve,
        reject,
      ) {
        var video_history = this.imageArr.filter(function (obj) {
          return obj.key === video_key;
        });
        if (video_history.length > 0) {
          console.log("Video already exist in array ", video_history);
          resolve(video_key);
          return;
        } else {
          this.imageArr.push({
            key: video_key,
            data: null,
            loaded: 0,
          });
          var r = new XMLHttpRequest();

          r.onload = function (
            video_url,
            video_key,
            video_index,
            loaderContext,
          ) {
            var video_obj = this.imageArr.filter(function (obj) {
              return obj.key === video_key;
            });
            video_obj[0].data = URL.createObjectURL(r.response);
            video_obj[0].loaded = 100;
            resolve(video_key);
          }.bind(this, video_url, video_key, video_index, loaderContext);
          r.open("GET", video_url);
          r.responseType = "blob";
          r.send();
        }
      }.bind(this, video_url, video_key, video_index, loaderContext),
    );
  }
  updateSections() {
    this.sections.forEach((section) => {
      // 1️⃣ Update background video
      if (section.bgvideo) {
        const key = this.getVideoKeyFromUrl(section.bgvideo);

        const blobUrl = this.getBlobUrl(key);
        // console.log(blobUrl);
        if (blobUrl) section.bgvideo = blobUrl;
      }

      // 2️⃣ Update all cards
      section.cards?.forEach((card) => {
        // singlevideo case
        if (card.image?.video) {
          const key = this.getVideoKeyFromUrl(card.image.video);
          const blobUrl = this.getBlobUrl(key);
          if (blobUrl) card.image.video = blobUrl;
        }

        // multivideo case (ERP example)
        if (Array.isArray(card.tag)) {
          card.tag.forEach((tag) => {
            tag.videos?.forEach((videoObj) => {
              if (videoObj.src) {
                const key = this.getVideoKeyFromUrl(videoObj.src);
                const blobUrl = this.getBlobUrl(key);
                if (blobUrl) videoObj.src = blobUrl;
              }
            });
          });
        }
      });
    });
  }

  updateLandingVideos() {
    this.landingvideo.forEach((item) => {
      const key = this.getVideoKeyFromUrl(item.video);
      const blobUrl = this.getBlobUrl(key);
      if (blobUrl) item.video = blobUrl;
    });
  }
  collectImages() {
    const imageSet = new Set(); // to avoid duplicates
    const addImage = (url) => {
      if (
        url &&
        typeof url === "string" &&
        /\.(jpg|jpeg|png|webp|gif)$/i.test(url)
      ) {
        imageSet.add(url);
      }
    };

    // Loop through all sections
    this.sections.forEach((section) => {
      // Section-level background images (if any)
      if (section.bgimage) addImage(section.bgimage);

      // Each card
      section.cards?.forEach((card) => {
        // card.image might be a string or object
        if (typeof card.image === "string") {
          addImage(card.image);
        } else if (card.image?.thumbnail) {
          addImage(card.image.thumbnail);
        }

        // If card has tag.images (array of images)
        if (Array.isArray(card.tag?.images)) {
          card.tag.images.forEach(addImage);
        }

        // If card has tag array (multi-video structure)
        if (Array.isArray(card.tag)) {
          card.tag.forEach((tag) => {
            if (Array.isArray(tag.videos)) {
              tag.videos.forEach((vid) => {
                if (vid.thumbnail) addImage(vid.thumbnail);
              });
            }
          });
        }
      });
    });

    // Convert to array of { key, url, status }
    this.imageToLoad = Array.from(imageSet).map((url) => ({
      key: this.getImageKeyFromUrl(url),
      url,
      status: "not_loaded",
    }));
  }
  getImageKeyFromUrl(url) {
    return url.split("/").pop(); // e.g. "thumb_AI_Subsurface_Data_Curator"
  }
  updateSectionImages() {
    if (!this.imageArr?.length || !this.sections?.length) return;

    const getKeyFromUrl = (url) => {
      if (!url) return null;
      const name = url.split("/").pop();
      return name; // handle spaces safely
    };

    const getData = (key) => {
      const found = this.imageArr.find((img) => img.key === key);
      return found?.data || null;
    };

    this.sections.forEach((section) => {
      section.cards?.forEach((card) => {
        // Case 1: card.image is a direct image string
        if (typeof card.image === "string") {
          const key = getKeyFromUrl(card.image);
          const data = getData(key);
          if (data) card.image = data;
        }

        // Case 2: card.image is an object (only replace thumbnail)
        else if (typeof card.image === "object" && card.image !== null) {
          if (card.image.thumbnail) {
            const key = getKeyFromUrl(card.image.thumbnail);
            const data = getData(key);
            if (data) card.image.thumbnail = data;
          }
        }

        // Case 4: Replace tag.images array
        if (card.tag?.images?.length) {
          card.tag.images = card.tag.images.map((url) => {
            const key = getKeyFromUrl(url);
            const data = getData(key);
            return data || url;
          });
        }
      });
    });

    // console.log(
    //   "✅ All section image URLs replaced with preloaded data (images only)"
    // );
  }

  getCardData(cardId) {
    return this.sections
      .flatMap((section) => section.cards)
      .find((card) => card.id === cardId);
  }
}

export default new Model();
